import angular from 'angular';
import * as _ from 'lodash';
import {hubConnection} from './jquery.signalR';

function initNewConnection(options) {
    let connection = null;
    if (options && options.rootPath) {
        connection = hubConnection(options.rootPath, {useDefaultPath: false});
    } else {
        connection = hubConnection();
    }

    connection.logging = (!!(options && options.logging));
    return connection;
}

function getConnection(options) {
    return initNewConnection(options);
}

function makeArray(array) {
    let ret = [];

    if (array !== null) {
        let i = array.length;
        // The window, strings (and functions) also have 'length'
        if (i === null || typeof array === "string" || _.isFunction(array) || array.setInterval)
            ret[0] = array;
        else
            while (i)
                ret[--i] = array[i];
    }

    return ret;
}

export class SignalRHub {
    constructor(hubName, options) {
        this.options = options;
        this.connection = getConnection(options);
        this.proxy = this.connection.createHubProxy(hubName);

        if (options && options.listeners) {
            Object.getOwnPropertyNames(options.listeners)
                .filter((propName) => typeof options.listeners[propName] === 'function')
                .forEach((propName) => {
                    this.on(propName, options.listeners[propName]);
                });
        }

        if (options && options.methods) {
            _.each(options.methods, (method) => {
                this[method] = () => {
                    let args = makeArray(arguments);
                    args.unshift(method);
                    return this.invoke.apply(this, args);
                };
            });
        }
        if (options && options.queryParams) {
            this.connection.qs = options.queryParams;
        }
        if (options && options.errorHandler) {
            this.connection.error(options.errorHandler);
        }
        if (options && options.stateChanged) {
            this.connection.stateChanged(options.stateChanged);
        }

        //Adding additional property of promise allows to access it in rest of the application.
        if (options.autoConnect === undefined || options.autoConnect) {
            this.promise = this.connect();
        }
    }


    on(event, fn) {
        this.proxy.on(event, fn);
    }

    invoke(method, args) {
        return this.proxy.invoke.apply(Hub.proxy, arguments)
    }

    disconnect() {
        this.connection.stop();
    }

    connect(queryParams) {
        let startOptions = {};
        if (this.options.transport) startOptions.transport = this.options.transport;
        if (this.options.jsonp) startOptions.jsonp = this.options.jsonp;
        if (!_.isUndefined(this.options.withCredentials)) startOptions.withCredentials = this.options.withCredentials;
        if (queryParams) this.connection.qs = queryParams;
        return this.connection.start(startOptions);
    };
}

export default angular.module('SignalR', [])
    .constant('$', window.jQuery)
    .factory('Hub', [function () {
        //This will allow same connection to be used for all Hubs
        //It also keeps connection as singleton.
        let globalConnections = [];


        return SignalRHub;
    }]);


// WEBPACK FOOTER //
// ./src/libs/angular-signalr-hub.js